module.exports = __webpack_public_path__ + "static/media/violation.17e00cf7.svg";